import { Mutation } from 'vuex'
import { SocialDistributionState } from '../types'

const resetOptions: Mutation<SocialDistributionState> = (state) => {
  state.options.pasteText = ''
  state.options.pasteDate = ''
}

export default resetOptions
